import React from "react";
import { connect } from "react-redux";
import { AgencyContainerStyled } from "./styled";
import { adminService } from "apiService";
// import { iconImages } from 'assets';
import { setReduxUserAuth } from 'actions';
import { ReactTable, ButtonCustom, SideContainer } from 'components';
import { Helmet } from "react-helmet";
import AgencyProfileContainer from '../SectionsAgencyDetail/AgencyProfileContainer'
import AgencyDetailContainer from '../AgencyDetailContainer'

class AgencyContainer extends React.Component {
  state = { data: [], isAddOpen: false, isDetailOpen: false, detailId: null };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let res = await adminService.GET_AGENCY_LIST();
    if (res && res.success) {
      this.setState({
        data: res.data,
      });
    }
  };

  handdleClickAdd = (e) => {
    this.setState({ isAddOpen: true })
  };
  handleClose = (e) => {
    this.setState({ isAddOpen: false, isDetailOpen: false, detailId: null })
  }

  handdleClickDetail = (e) => {
    this.setState({ isDetailOpen: true, detailId: e })
    // this.props.history.push(ROUTE_PATH.A_AGENCY + "/" + e);
  };

  handleSaveSuccess = () => {
    this.fetchData()
  }

  handleEditSuccess = () => {
    this.fetchData()
  }

  render() {
    const { data, isAddOpen, isDetailOpen, detailId } = this.state;
    return (
      <AgencyContainerStyled>
        <Helmet>
          <title>admin</title>
        </Helmet>
        <div className="tab_layout">
          <div className="title_layout">Company System</div>
          <div className="button_layer">
            <ButtonCustom
              theme_yellow_2
              label="New Company"
              onClick={this.handdleClickAdd}
            />
          </div>
        </div>
        <div className="table-wrapper">
          <ReactTable
            columns={columns({ handdleClickDetail: this.handdleClickDetail })}
            data={data}
          />
        </div>
        <SideContainer title="New Company" isShow={isAddOpen} handleClose={this.handleClose}>
          <AgencyProfileContainer handleClose={this.handleClose} handleSaveSuccess={this.handleSaveSuccess} />
        </SideContainer>
        <SideContainer title="Company Detail" isShow={isDetailOpen} handleClose={this.handleClose}>
          <AgencyDetailContainer handleClose={this.handleClose} handleSaveSuccess={this.handleSaveSuccess} detailId={detailId} isDetailOpen={isDetailOpen} handleEditSuccess={this.handleEditSuccess} />
        </SideContainer>
      </AgencyContainerStyled>
    );
  }
}

const columns = ({ handdleClickDetail }) => [
  {
    Header: "Displayname",
    accessor: "displayname",
    style: { width: "350px" },
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Detail",
    accessor: "id",
    style: { width: "10px" },
    Cell: (e) => (
      <ButtonCustom theme_yellow_2 onClick={() => handdleClickDetail(e.value)} label="detail" />
    ),
  },
];

const mapStateToProps = (state) => ({
  authRedux: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  setReduxUserAuth: (data) => dispatch(setReduxUserAuth(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgencyContainer);
